import { InjectionToken } from '@angular/core';

export const DATABASE_ID_PROVIDER: InjectionToken<IDatabaseIdProvider> = new InjectionToken('DATABASE_ID_PROVIDER');

export interface IDatabaseIdProvider {
	getDatabaseId();
}

export class DefaultDatabaseIdProvider implements IDatabaseIdProvider {
	private databaseId: string = null;

	setDatabaseId(databaseId: string): void {
		this.databaseId = databaseId;
	}

	getDatabaseId(): string {
		return this.databaseId;
	}
}
